export const ITG1351_ALL_OUT = 'ITG1351';
export const ITG1356_LOW_MOCA = 'ITG1356';
export const ITG1391_DEGRADED_INTERNET = 'ITG1391';
export const ITG1393_MODEM_OFFLINE = 'ITG1393';
export const ITG1394_DEVICE_OFFLINE = 'ITG1394';
export const ITG1457_ABANDONED_TRUCK_ROLL = 'ITG1457';
export const ITG1505_BOOTFILE = 'ITG1505';
export const ITG6009_GATEWAY_SPEED_TEST = 'ITG6009';
